import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import voiceEvacuation from '../../../../../src/assets/images/voice-evacuation.png';
import ASD from '../../../../../src/assets/images/ASD.png';
import aerosol from '../../../../../src/assets/images/aerosol.png';
import FireAlarm from '../../../../../src/assets/images/fire-alarm.png';
import cleanagent from '../../../../../src/assets/images/clean-agent.png';
import fireextinguisher from '../../../../../src/assets/images/fire-extinguisher.png';
import firehosecabinet from '../../../../../src/assets/images/fire-hose-cabinet.png';
import firewatertank from '../../../../../src/assets/images/fire-water-tank.png';
import foamsystem from '../../../../../src/assets/images/foam-system.png';
import kitchenhoodfs from '../../../../../src/assets/images/kitchen-hood.png';
import standpipe from '../../../../../src/assets/images/standpipe.png';
import firepump from '../../../../../src/assets/images/firepump.png';
import firehydrant from '../../../../../src/assets/images/fire-hydrant.png';
import fireprotect from '../../../../../src/assets/images/fireprotect.png';
import defaulr from '../../../../../src/assets/images/defaulr.jpeg';
import FormLayout from "../FormLayout";
import { useToast } from "../../../../Components/Others/ToastServices";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import Pagination from "../../../../Components/Utils/Pagenation";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import ImportForms from "./ImportForms";
import MultiEditForms from "./MultiEditForms";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import CloseIcon from "../../../../Components/Icons/Close";
import { NuDate } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";

const formImages = {
  "Fire Protection System - Summary": fireprotect,
  "Fire Pump": firepump,
  "Fire Water Tanks": firewatertank,
  "Fire / Foam Hose Cabinet": firehosecabinet,
  "Fire / Foam Hose Cabinet Details": firehosecabinet,
  "Fire Extinguisher": fireextinguisher,
  "Fire Extinguisher Details": fireextinguisher,
  "Clean Agent Fire Suppression System": cleanagent,
  "Fire Alarm System": FireAlarm,
  "Aspirating Smoke Detection System": ASD,
  "Asd System": ASD,
  "Voice Evacuation System /Pava": voiceEvacuation,
  "Stand Pipe Hose System": standpipe,
  "Foam Fire Suppression System": foamsystem,
  "Fire Hydrant": firehydrant,
  "Kitchen Hood Fire Suppression Sys.": kitchenhoodfs,
  "Aerosol Fire Suppression System": aerosol,
};

// Using a simple document icon as default
const defaultImage = defaulr;

function FormsIndex() {
   const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toast = useToast();
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

  //  const { value: FormType} = useFetchMataData(
  //        `/dropdown/dropdown-details/`,
  //        "Form_Types"
  //      );
     const [selectedCategory, setSelectedCategory] = useState("");
  const [FormType, setFormType] = useState([]);

//  useEffect(() => {
//   axiosInstance
//     .get("/form/all-forms/with-category")
//     .then((res) => {
//       setFormType(res.data.data || []);
//     })
//     .catch((err) => {
//       console.error("API error:", err);
//     });
// }, []);

  useEffect(() => {
    axiosInstance.get("/form/all-forms/with-category")
      .then((res) => {
        const enabledForms = res.data.data?.filter(form => form.enabled) || [];
        // enabledForms.push({ id: 2, name: "Generator", value: "generator", label: "Generator", enabled: true });
        // enabledForms.push({id: 3, name: "Fire", value: "fire", label: "Fire", enabled: true});

        setFormType(enabledForms);
        
        // Set first enabled form as active tab if none is selected
        if (enabledForms.length > 0 && !activeTab) {
          setActiveTab(enabledForms[0].id);
          setParams(prev => ({
            ...prev,
            category: enabledForms[0].id
          }));
        }
      })
      .catch(console.error);
  }, []);



const [formList, setFormList] = useState([]);
const [loading, setLoading] = useState(false);

const [selected, setSelected] = useState([]); // always an array

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    category: "",
    
  });
  
  const { data, totalCount, getData, dataLoading,total } = UseGetDataSearch(
    "/form/all-forms",
   params
  );

  const handleTabClick = (formTypeValue) => {
  setActiveTab(formTypeValue);
  setParams((prev) => ({
    ...prev,
    category: formTypeValue,
    page: 1 
  }));
};


useEffect(() => {
  const fetchForms = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/form/all-forms", {
        params,
      });
      setFormList(response.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch forms", err);
    } finally {
      setLoading(false);
    }
  };

  if (params.category) {
    fetchForms();
  }
}, [params]);


  
 
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);





  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const handleMultiDelete = (data) => {
    axiosInstance
      .delete(`items/multi-delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: { ids: data },
      })
      .then((res) => {
        if (res.data?.status === true) {
          if (res?.data?.not_deleted_ids.length <= 0) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          } else {
            toast.open({
              type: "warning",
              message: "Success",
              description:
                `${res.data?.msg} \n Some Products has dependenies` ||
                "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          }
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Delete UnSuccessfull",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network Error.",
        });
      });
  };

  console.log("Data", data);
  
   const [valueOfSearch,setValuesofSearch] = useState("")
     function searchFunction(e) {
   
       
       setValuesofSearch(e?.target?.value)
       setParams({ ...params, search: e?.target?.value, page:1 });
       setPage(1)
     }

       const [formData, setFormData] = useState({
         // Basic Information
         facilityName: '',
         facilityAddress: '',
         testType: 'Monthly',
         inspectorCertification: '',
         testDate: '',
         inspectorName: '',
         
         // Generator Information
         manufacturer: '',
         model: '',
         serialNumber: '',
         fuelType: 'Diesel',
         ratedPower: '',
         ratedVoltage: '',
         ratedFrequency: '',
         
         // Test Parameters
         loadPercentage: '',
         runTime: '',
         oilPressure: '',
         coolantTemp: '',
         batteryVoltage: '',
         fuelLevel: '',
         
         // Test Results
         voltageOutput: '',
         frequencyOutput: '',
         issuesFound: '',
         correctiveActions: '',
         nextTestDate: '',
         
         // Additional Details
         ambientTemperature: '',
         humidity: '',
         weatherConditions: 'Clear',
     
       // Visual Inspection
       generalCondition: "Good",
       corrosionPresent: false,
       leaksPresent: false,
       mountingSecure: false,
       ventilationAdequate: false,
     
       // Fuel System
       fuelLevel: "",
       fuelQuality: "Good",
       fuelFilterCondition: "Good",
       fuelPumpOperation: "Normal",
       fuelLinesSecure: false,

        //FireFight
        inspectorName: "",
    startDate: "",
    endDate: "",
    totalDays: "",
    persons: "",
    serviceType: [],
    systemType: [],
    observation: "",
    actionTaken:"",
    qty:"",
    desc:"",
    person1:"",
    empcode:"",
    contactNo:"",
    date:"",
    person2:"",
    empcode1:"",
    contactNo1:"",
    date1:"",
       });
     
       const handleChange = (e) => {
         const { name, value } = e.target;
         setFormData(prevState => ({
           ...prevState,
           [name]: value
         }));
       };
     
       const handleSubmit = (e) => {
         e.preventDefault();
         console.log('Form submitted:', formData);
         alert('Test documentation submitted successfully!');
       };
     
const [activeTab, setActiveTab] = useState("");

useEffect(() => {
  if (FormType?.length > 0 && !activeTab) {
    const defaultType = FormType[0].value;
    setActiveTab(defaultType);
    setParams((prev) => ({ ...prev, category: defaultType }));
  }
}, [FormType]);

const [compliance, setCompliance] = useState({
    nfpa: true,
    localCode: true,
    manufacturer: true,
    notes: "",
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCompliance((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleNotesChange = (e) => {
    setCompliance((prev) => ({
      ...prev,
      notes: e.target.value,
    }));
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const rows = Array.from({ length: 10 }, (_, i) => i + 1); // 10 rows

  return (
    <>
    <FormLayout
            searchFun={searchFunction}
            searchValue={valueOfSearch}
                  total={totalCount}

    >
    <div className="w-full h-full  mt-0.5 ">
     
      <div className=" w-full h-[calc(100vh-180px)] bg-white  rounded-md overflow-hidden px-4 py-2">
        {/* <p className=" text-xs 2xl:text-sm font-medium">Total Form : {data.length||0}</p> */}
        <div className=" w-full h-[calc(100vh-235px)] ">
         <div className="flex flex-wrap">
 {FormType?.filter(form => form.enabled).map((form) => (
  <button
    key={form.value}
    onClick={() => handleTabClick(form.value)}
    className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
      activeTab === form.value
        ? "text-baseColor-primary underline underline-offset-4 decoration-2"
        : "text-gray-500"
    }`}
  >
    {form.label}
  </button>
))}

</div>



        <div className="w-full max-h-[calc(100vh-235px)] grid grid-cols-2 md:grid-cols-5 lg:grid-cols-7 gap-4 overflow-y-auto py-4">
  {data &&
    data.map((item, i) => {
      return (
        <Link
          key={i}
          to={`/forms/insforms/view/${item?.id}`}
          state={{ data: item }}
          className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg"
        >
          {/* Serial Number Top-Left */}
          <div className="h-[30px] w-full">
          <span className="absolute top-1 left-2 text-xs  text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
            {i + 1}
          </span>
</div>
          <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
            <img 
                      src={formImages[item.formName] || defaultImage} 
                      alt={item.formName}
                      className="w-16 h-16 object-contain"
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
            <p className="line-clamp-3 text-xs text-center">
              {item?.formName || ""}
            </p>
          </div>
        </Link>
      );
    })}


</div>
{
  activeTab === "generator" && (


      <div className="bg-white h-full w-full rounded-md flex flex-col overflow-y-auto p-4">
        {/* Header */}
        <div className="bg-white rounded-lg p-6 mb-4 shadow-sm border border-gray-200">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Emergency Power System Test (NFPA 110)</h1>
          <p className="text-gray-600">Comprehensive generator testing and maintenance documentation</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Basic Information Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Basic Information</h2>
            <p className="text-gray-600 mb-4">Facility and inspector information for the emergency power test</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Facility Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="facilityName"
                  value={formData.facilityName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter facility name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Test Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="testDate"
                  value={formData.testDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Facility Address
                </label>
                <textarea
                  name="facilityAddress"
                  value={formData.facilityAddress}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter complete facility address"
                  rows={3}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Inspector Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="inspectorName"
                  value={formData.inspectorName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter inspector name"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Test Type
                </label>
                <select
                  name="testType"
                  value={formData.testType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                >
                  <option value="Monthly">Monthly Test</option>
                  <option value="Quarterly">Quarterly Test</option>
                  <option value="Annual">Annual Test</option>
                  <option value="Emergency">Emergency Test</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Inspector Certification
                </label>
                <input
                  type="text"
                  name="inspectorCertification"
                  value={formData.inspectorCertification}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter certification details"
                />
              </div>
            </div>

            <div className="bg-red-50 rounded-xl shadow-inner p-6 border border-red-200 mt-5">
  <h2 className="text-lg font-semibold text-gray-800">
    NFPA 110 Maintenance Schedule Reference
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
    <div>
      <h3 className="font-semibold text-gray-700 mb-2">Weekly Tasks</h3>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Run generator in auto mode check</li>
        <li>Verify fuel/oil/coolant levels</li>
        <li>Check for alarms and faults</li>
      </ul>
    </div>

    <div>
      <h3 className="font-semibold text-gray-700 mb-2">Monthly Tasks</h3>
      <ul className="list-disc list-inside text-gray-700 space-y-1">
        <li>Exercise generator under load (per OEM)</li>
        <li>Inspect battery and charging system</li>
        <li>Inspect air intake and exhaust</li>
      </ul>
    </div>
  </div>
</div>
          </div>

          {/* Generator Information Section */}
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Generator Information</h2>
            <p className="text-gray-600 mb-4">Technical specifications and details of the emergency generator</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Manufacturer <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="manufacturer"
                  value={formData.manufacturer}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="e.g., Caterpillar, Cummins, Kohler"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Model <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter model"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Serial Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="serialNumber"
                  value={formData.serialNumber}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter serial number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Fuel Type
                </label>
                <select
                  name="fuelType"
                  value={formData.fuelType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                >
                  <option value="Diesel">Diesel</option>
                  <option value="Gasoline">Gasoline</option>
                  <option value="Propane">Propane</option>
                  <option value="Natural Gas">Natural Gas</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rated Power (kW) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="ratedPower"
                  value={formData.ratedPower}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter rated power in kW"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rated Voltage (V)
                </label>
                <input
                  type="number"
                  name="ratedVoltage"
                  value={formData.ratedVoltage}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                  placeholder="Enter rated voltage"
                />
              </div>

               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Installation Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="installationDate"
                  value={formData.installationDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>

               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Last Maintenance Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  name="lastMaintenanceDate"
                  value={formData.lastMaintenanceDate}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
                />
              </div>

            </div>
          </div>


{/* Visual Inspection Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Visual Inspection</h2>
  <p className="text-gray-600">General condition and visual assessment</p>

  <div className="mt-3 space-y-4 flex gap-5">
    {/* General Condition */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        General Condition
      </label>
      <div className="flex gap-4">
        {["Excellent", "Good", "Fair", "Poor"].map((condition) => (
          <label key={condition} className="flex items-center gap-2">
            <input
              type="radio"
              name="generalCondition"
              value={condition}
              checked={formData.generalCondition === condition}
              onChange={handleChange}
            />
            {condition}
          </label>
        ))}
      </div>
    </div>

    {/* Checkboxes */}
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="leaksPresent"
        checked={formData.leaksPresent}
        onChange={(e) =>
          setFormData({ ...formData, leaksPresent: e.target.checked })
        }
      />
      <span>Leaks Present</span>
    </div>
  </div>

<div className=' flex gap-5 mt-4'>
<div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="corrosionPresent"
        checked={formData.corrosionPresent}
        onChange={(e) =>
          setFormData({ ...formData, leaksPresent: e.target.checked })
        }
      />
      <span>Corrosion Present</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="ventilationAdequate"
        checked={formData.ventilationAdequate}
        onChange={(e) =>
          setFormData({ ...formData, ventilationAdequate: e.target.checked })
        }
      />
      <span>Ventilation Adequate</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="corrosionPresent"
        checked={formData.corrosionPresent}
        onChange={(e) =>
          setFormData({ ...formData, corrosionPresent: e.target.checked })
        }
      />
      <span>Mounting Secure</span>
    </div>
</div>
  
</div>

{/* Fuel System Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Fuel System</h2>
  <p className="text-gray-600">
    Fuel level, quality, and system components
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Level (%)
      </label>
      <input
        type="number"
        name="fuelLevel"
        value={formData.fuelLevel}
        onChange={handleChange}
        placeholder="Enter fuel level"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Quality
      </label>
      <select
        name="fuelQuality"
        value={formData.fuelQuality}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Filter Condition
      </label>
      <select
        name="fuelFilterCondition"
        value={formData.fuelFilterCondition}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Fuel Pump Operation
      </label>
      <select
        name="fuelPumpOperation"
        value={formData.fuelPumpOperation}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Normal">Normal</option>
        <option value="Irregular">Irregular</option>
        <option value="Failing">Failing</option>
      </select>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="fuelLinesSecure"
        checked={formData.fuelLinesSecure}
        onChange={(e) =>
          setFormData({ ...formData, fuelLinesSecure: e.target.checked })
        }
      />
      <span>Fuel Lines Secure</span>
    </div>
  </div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Electrical System</h2>
  <p className="text-gray-600">
    Battery status, wiring, and component conditions
  </p>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Battery Voltage (V)
      </label>
      <input
        type="number"
        name="batteryVoltage"
        value={formData.batteryVoltage}
        onChange={handleChange}
        placeholder="Enter battery voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Battery Condition
      </label>
      <select
        name="batteryCondition"
        value={formData.batteryCondition}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Charging System
      </label>
      <select
        name="chargingSystem"
        value={formData.chargingSystem}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Good">Good</option>
        <option value="Fair">Fair</option>
        <option value="Poor">Poor</option>
      </select>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Control Panel
      </label>
      <select
        name="controlPanel"
        value={formData.controlPanel}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      >
        <option value="Normal">Normal</option>
        <option value="Irregular">Irregular</option>
        <option value="Failing">Failing</option>
      </select>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="batteryTerminal"
        checked={formData.batteryTerminal}
        onChange={(e) =>
          setFormData({ ...formData, batteryTerminal: e.target.checked })
        }
      />
      <span>Battery Terminals Clean</span>
    </div>
  </div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Startup Test</h2>
  <p className="text-gray-600">Manual and automatic start test results</p>

  <div className="mt-3 space-y-4  gap-5">
    {/* General Condition */}
  <div className=' flex gap-5 mt-4'>
<div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="manualStartSuccessful"
        checked={formData.manualStartSuccessful}
        onChange={(e) =>
          setFormData({ ...formData, manualStartSuccessful: e.target.checked })
        }
      />
      <span>Manual Start Successful</span>
    </div>

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="automaticStartSuccessful"
        checked={formData.automaticStartSuccessful}
        onChange={(e) =>
          setFormData({ ...formData, automaticStartSuccessful: e.target.checked })
        }
      />
      <span>Automatic Start Successful</span>
    </div>

  </div>

  <div className=' flex gap-5 mt-4'>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Startup Time (seconds)
      </label>
      <input
        type="number"
        name="startupTime"
        value={formData.startupTime}
        onChange={handleChange}
        placeholder="Enter startup time"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Initial Voltage (V)
      </label>
      <input
        type="number"
        name="initialVoltage"
        value={formData.initialVoltage}
        onChange={handleChange}
        placeholder="Enter initial voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Initial Frequency (Hz)
      </label>
      <input
        type="number"
        name="initialFrequency"
        value={formData.initialFrequency}
        onChange={handleChange}
        placeholder="Enter initial frequency"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

     <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Oil Pressure (PSI)
      </label>
      <input
        type="number"
        name="oilPressure"
        value={formData.oilPressure}
        onChange={handleChange}
        placeholder="Enter oil pressure"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>
  </div>

  
</div>
</div>

<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Load Test</h2>
  <p className="text-gray-600">Generator performance under load conditions</p>

   <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
       Load Applied (%)
      </label>
      <input
        type="number"
        name="loadApplied"
        value={formData.loadApplied}
        onChange={handleChange}
        placeholder="Enter load applied"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Test Duration (minutes)
      </label>
      <input
        type="number"
        name="testDuration"
        value={formData.testDuration}
        onChange={handleChange}
        placeholder="Enter test duration"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Loaded Voltage (V)
      </label>
      <input
        type="number"
        name="loadedVoltage"
        value={formData.loadedVoltage}
        onChange={handleChange}
        placeholder="Enter loaded voltage"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Loaded Frequency (Hz)
      </label>
      <input
        type="number"
        name="loadedFrequency"
        value={formData.loadedFrequency}
        onChange={handleChange}
        placeholder="Enter loaded frequency"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Oil Pressure (PSI)
      </label>
      <input
        type="number"
        name="oilPressure"
        value={formData.oilPressure}
        onChange={handleChange}
        placeholder="Enter oil pressure"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Coolant Temp (°F)
      </label>
      <input
        type="number"
        name="coolantTemp"
        value={formData.coolantTemp}
        onChange={handleChange}
        placeholder="Enter coolant temperature"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
      />
    </div>

    

    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        name="performanceSatisfactory"
        checked={formData.performanceSatisfactory}
        onChange={(e) =>
          setFormData({ ...formData, performanceSatisfactory: e.target.checked })
        }
      />
      <span>Performance Satisfactory</span>
    </div>
  </div>
</div>

{/* Maintenance Performed Section */}
<div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
  <h2 className="text-xl font-semibold text-gray-800">Maintenance Performed</h2>
  <p className="text-gray-600">
    Record all maintenance activities performed during this inspection
  </p>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
    {[
      "Oil Changed",
      "Oil Filter Replaced",
      "Fuel Filter Replaced",
      "Air Filter Replaced",
      "Spark Plugs Replaced",
      "Battery Maintenance",
      "Coolant System Flushed",
      "Belts Inspected",
      "Belts Replaced",
    ].map((item) => (
      <label key={item} className="flex items-center gap-2">
        <input
          type="checkbox"
          name={item.replace(/\s+/g, "").toLowerCase()}
          checked={formData[item.replace(/\s+/g, "").toLowerCase()] || false}
          onChange={(e) =>
            setFormData({
              ...formData,
              [item.replace(/\s+/g, "").toLowerCase()]: e.target.checked,
            })
          }
        />
        {item}
      </label>
    ))}
  </div>

  <div className="mt-4">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Other Maintenance Performed
    </label>
    <textarea
      name="otherMaintenance"
      value={formData.otherMaintenance || ""}
      onChange={handleChange}
      placeholder="Describe any additional maintenance activities..."
      rows={3}
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
    />
  </div>
</div>

 <div className="bg-white rounded-xl shadow-sm border p-6 flex items-center justify-between">
      {/* Left Side Content */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">
          Deficiencies and Recommendations
        </h2>
        <p className="text-sm text-gray-500">
          Document any issues found and recommended corrective actions
        </p>
      </div>

      {/* Right Side Button */}
      <button className="px-4 py-2 text-sm font-medium text-red-600 border border-red-600 rounded-lg hover:bg-red-600 hover:text-white transition">
        Add Deficiency
      </button>
    </div>

     <div className="bg-white rounded-xl shadow-sm border p-6 space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Test Summary</h2>
        <p className="text-sm text-gray-500">
          Overall test results and conclusions
        </p>
      </div>

      {/* Overall Result, Next Test Due, Next Maintenance Due */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Overall Result
          </label>
          <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500">
            <option>Pass</option>
            <option>Fail</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Test Due
          </label>
          <input
            type="date"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Next Maintenance Due
          </label>
          <input
            type="date"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
          />
        </div>
      </div>

      {/* Recommendations */}
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Recommendations
        </label>
        <textarea
          rows="3"
          placeholder="Enter any additional recommendations..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
        />
      </div>

      <hr />

      {/* Inspector + Facility Representative */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Inspector Signature */}
        <div>
          <h3 className="font-semibold text-gray-900 text-sm mb-2">
            Inspector Signature
          </h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">
                Digital Signature
              </label>
              <input
                type="text"
                placeholder="Type full name for digital signature"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">Date</label>
              <input
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
        </div>

        {/* Facility Representative */}
        <div>
          <h3 className="font-semibold text-gray-900 text-sm mb-2">
            Facility Representative
          </h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">
                Representative Name
              </label>
              <input
                type="text"
                placeholder="Enter facility representative name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">
                Digital Signature
              </label>
              <input
                type="text"
                placeholder="Type full name for digital signature"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
        </div>
        <div className="space-y-3">
            <div>
              <label className="block text-sm text-gray-700">Date</label>
              <input
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
              />
            </div>
          </div>
      </div>
    </div>

<div className="bg-white rounded-xl shadow-sm border p-6 space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Test Summary</h2>
        <p className="text-sm text-gray-500">
          Overall test results and conclusions
        </p>
      </div>
           <div className="flex flex-wrap gap-6">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="nfpa"
              checked={compliance.nfpa}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            NFPA 110 Compliant
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="localCode"
              checked={compliance.localCode}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            Local Code Compliant
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="manufacturer"
              checked={compliance.manufacturer}
              onChange={handleCheckboxChange}
              className="h-4 w-4 text-red-600"
            />
            Manufacturer Guidelines Followed
          </label>
        </div>

        <div>
          <textarea
            placeholder="Enter any compliance-related notes or exceptions..."
            value={compliance.notes}
            onChange={handleNotesChange}
            className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-red-400"
            rows="4"
          />
        </div>

        {/* <div className="flex justify-end gap-4">
          <button
            type="button"
            className="px-4 py-2 border rounded-lg hover:bg-gray-100"
            onClick={() => alert("Going back to start")}
          >
            Back to Start
          </button>
          <button
            type="submit"
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Submit Test Report
          </button>
        </div> */}
        </div>
        </form>
      </div>
      )}

      {
  activeTab === "fire" && (
      <div className="bg-white h-full w-full rounded-md flex flex-col overflow-y-auto p-4">
        <div className="bg-white rounded-lg p-6 mb-4 shadow-sm border border-gray-200">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">FIRE PROTECTION SYSTEM</h1>
          <h1 className="text-xl font-bold text-gray-800 mb-2">FIELD SERVICE REPORT</h1>

        </div>

         {/* Header Section */}
         <div className="border p-3 rounded-md mt-3 text-gray-800">
          <h3 className="font-semibold text-xl mb-2 ">
          TECHNICIANS / INSPECTOR DETAILS 
        </h3>
        
     <div className="border border-gray-300 rounded-md text-sm mt-3">
  <table className="w-full border-collapse">
    <thead>
      <tr className="bg-red-100 text-center font-semibold">
        <th className="border border-gray-300 p-2">Name</th>
        <th className="border border-gray-300 p-2">Start Date</th>
        <th className="border border-gray-300 p-2">End Date</th>
        <th className="border border-gray-300 p-2">Total Days / Hours</th>
        <th className="border border-gray-300 p-2">No. of Persons</th>
      </tr>
    </thead>
    <tbody>
      <tr className="text-center">
        <td className="border border-gray-300 p-1">
          <input
            type="text"
            name="inspectorName"
            placeholder="Name"
            value={formData.inspectorName}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="datetime-local"
            name="startDate"
            value={formData.startDate}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="datetime-local"
            name="endDate"
            value={formData.endDate}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="text"
            name="totalDays"
            placeholder="Total Days/Hours"
            value={formData.totalDays}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="number"
            name="persons"
            placeholder="No. of Persons"
            value={formData.persons}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div> 
</div>


      {/* Inspection / Service Type */}
      <div className="border p-3 rounded-md mt-3">
        <h3 className="font-semibold text-xl text-gray-800 mb-2">
          INSPECTION / SERVICE TYPE
        </h3>
        <div className="grid grid-cols-3 gap-2 text-sm text-gray-800">
          {[
            "Contractual",
            "Non-Contractual",
            "Comprehensive",
            "Semi-Comprehensive",
            "Non-Comprehensive",
            "Monthly",
            "Quarterly",
            "On Call",
            "Emergency Call",
            "Others",
            "Inspection",
            "General Service",
            "Repair Works",
            "New Installations",
          ].map((item) => (
            <label key={item} className="grid grid-cols-2 items-center ">
              {item}

              <input
                type="checkbox"
                checked={formData.serviceType.includes(item)}
                onChange={() => handleCheckboxChange("serviceType", item)}
              />
            </label>
          ))}
        </div>
      </div>

      {/* Type of Systems */}
      <div className="border p-3 rounded-md mt-3 text-gray-800">
        <h3 className="font-semibold text-xl mb-2">TYPE OF SYSTEMS</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
          {[
            "Water Based Sprinkler System",
            "Foam Based Sprinkler System",
            "Stand Pipe & Hose System",
            "Deluge System",
            "Pre-Action System",
            "Fire Suppression System",
            "Fire Alarm System",
            "Fire Extinguishers",
            "Aspirating Smoke Detector System",
            "Emergency & Exit Light System",
            "Fire Hydrant",
            "Fire Pump",
            "Breeching Inlet / FDC",
            "Voice Evacuation System/PAVA",
            "Central Battery System",
            "Others",
          ].map((item) => (
            <label key={item} className="grid grid-cols-2 items-center">
              {item}

              <input
                type="checkbox"
                checked={formData.systemType.includes(item)}
                onChange={() => handleCheckboxChange("systemType", item)}
              />
            </label>
          ))}
        </div>
      </div>

      {/* Observation / Complaint */}
      <div className="border p-3 rounded-md mt-3 text-gray-800">
        <h3 className="font-semibold text-xl mb-2">
          OBSERVATION / CUSTOMER COMPLAINT
        </h3>
        <textarea
          name="observation"
          value={formData.observation}
          onChange={handleInputChange}
          rows={5}
          className="w-full border rounded p-2 text-sm resize-none"
          placeholder="Enter observations or complaints here..."
        />
      </div>

      {/* Action Req */}
      <div className="border p-3 rounded-md text-gray-800 mt-3">
        <h3 className="font-semibold text-xl mb-2">
           ACTION REQUIRED/TAKEN
        </h3>
        <textarea
          name="actionTaken"
          value={formData.actionTaken}
          onChange={handleInputChange}
          rows={5}
          className="w-full border rounded p-2 text-sm resize-none"
          placeholder="Enter here..."
        />
      </div>

<div className=" mt-5 text-gray-800">
  <h3 className="font-semibold text-xl mb-2">
           DAMAGES/REPLACEMENT /SPARE PARTS - DETAILS
        </h3>
        <div className="border border-gray-300 text-sm mt-3">
      {/* Header */}
      
      <div className="grid grid-cols-12 border-b border-gray-300 font-semibold text-center bg-red-100">
        <div className="col-span-1 border-r border-gray-300 p-1">S.No.</div>
        <div className="col-span-9 border-r border-gray-300 p-1">Description</div>
        <div className="col-span-2 p-1">Qty</div>
      </div>

      {/* Rows */}
      {rows.map((row) => (
        <div
          key={row}
          className="grid grid-cols-12 border-b border-dotted border-gray-300 last:border-b-0 text-center"
        >
          <div className="col-span-1 border-r border-gray-300 p-1">{row}</div>
          <div className="col-span-9 border-r border-gray-300 p-1 text-cebter w-full"><input
          type="text"
          name="desc"
          placeholder="Enter Here.."
          value={formData.desc}
          onChange={handleInputChange}
          className="col-span-1 border rounded p-2 text-sm items-center w-full"
        /></div>
          <div className="col-span-2 p-1"><input
          type="number"
          name="qty"
          placeholder="Quantity"
          value={formData.qty}
          onChange={handleInputChange}
          className="col-span-1 border rounded p-2 text-sm"
        /></div>
        </div>
      ))}
    </div>
</div>

<div className="border border-gray-300 text-sm mt-5 text-gray-800">
  {/* Header */}
  <div className="border-b border-gray-300 bg-red-100 text-gray-800 font-semibold text-xl text-center">
    <div className="p-1">ACKNOWLEDGEMENT</div>
  </div>

  {/* Column titles */}
  <div className="grid grid-cols-6 border-b border-gray-300 font-semibold text-center text-gray-800">
    <div className="col-span-1 border-r border-gray-300 p-1 bg-red-50">For</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Authorized Person</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Employee Code</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Contact No.</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Date</div>
    <div className="col-span-1 p-1">Signature</div>
  </div>

  {/* Row 1 */}
  <div className="grid grid-cols-6 border-b border-gray-300 text-center">
    <div className="col-span-1 border-r border-gray-300 p-1 font-medium bg-red-50">
      Falcon Fire
    </div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="person1"
            placeholder="Name"
            value={formData.person1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="empcode"
            placeholder="Employee Code"
            value={formData.empcode}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="number"
            name="contactNo"
            placeholder="Contact No."
            value={formData.contactNo}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="date"
            name="date"
            placeholder="date"
            value={formData.date}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 p-1"></div>
  </div>

  {/* Row 2 */}
  <div className="grid grid-cols-6 text-center">
    <div className="col-span-1 border-r border-gray-300 p-1 font-medium bg-red-50">
      Client
    </div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="person2"
            placeholder="Name"
            value={formData.person2}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="empcode1"
            placeholder="Employee Code"
            value={formData.empcode1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="number"
            name="contactNo1"
            placeholder="Contact No."
            value={formData.contactNo1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="date"
            name="date1"
            placeholder="date"
            value={formData.date1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 p-1"></div>
  </div>
</div>



      {/* Submit */}
      {/* <div className="flex justify-center">
        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Submit
        </button>
      </div> */}

        
</div>

  )}
        </div>
        
      </div>
    <div className=" w-full h-[40px] pb-4 bg-white">
          <Pagination
            page={page}
            setPage={setPage}
            totalCount={totalCount}
            pageCount={pageCount}
            setPageCount={setPageCount}
          />
        </div>
     
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => {
          handleMultiDelete(listofNumbers);
        }}
        closeModal={() => setShowDelete(false)}
      />

     
    </div>
    </FormLayout></>
  );
}

export default FormsIndex;
